import { Blockquote } from '@tiptap/extension-blockquote';
import * as style from './featuredQuote.module.css';

export const FeaturedQuote = Blockquote.extend({
   name: 'featuredQuote',
}).configure({
   HTMLAttributes: {
      class: style.featuredQuote,
   },
});
